export default "__VITE_ASSET__Dq_zf9pk__"